import React, { useCallback } from 'react';
import { Col, Container, Row } from 'react-grid-system';
import { useDispatch, useSelector } from 'react-redux';
import FlashMessage from '../../components/FlashMessage';
import { FullPageLoader } from '../../components/Loading';
import RepositCard from '../../components/Reposit/RepositCard';
import { P1 } from '../../components/Typography';
import { createLoadingSelector } from '../../redux/loading/loading.selector';
import { getOrganizationById } from '../../redux/organization/organization.selectors';
import {
  CREATE_ORG_GROUP_STORE_KEY,
  UPDATE_ORG_GROUP_STORE_KEY,
  updateOrganizationGroupRequested,
} from '../../redux/organization-group/organization-group.actions';
import { FLASH_MESSAGE_TIMEOUT, useFlashMessage } from '../FlashMessage';
import OrganizationGroupEditor, { OrganizationGroupChanges } from './OrganizationGroupEditor';

interface OrganizationGroupProps {
  organizationId: string;
}

const OrganizationGroup: React.FC<OrganizationGroupProps> = ({ organizationId }) => {
  const dispatch = useDispatch();
  const organization = useSelector((state: Parameters<typeof getOrganizationById>[0]) =>
    getOrganizationById(state, organizationId),
  );
  const [flashMessagePayload, dismissFlashMessage] = useFlashMessage([UPDATE_ORG_GROUP_STORE_KEY, CREATE_ORG_GROUP_STORE_KEY]);
  const isUpdateLoading = useSelector(createLoadingSelector([UPDATE_ORG_GROUP_STORE_KEY]));
  const onUpdate = useCallback(
    (changes: OrganizationGroupChanges) => {
      dispatch(updateOrganizationGroupRequested({ organizationId, ...changes }));
    },
    [dispatch, organizationId],
  );

  if (!organization) return <FullPageLoader />;

  return (
    <Container>
      <Row>
        <Col sm={12}>
          <RepositCard
            title="Parent"
            flashMessage={
              flashMessagePayload ? (
                <FlashMessage
                  payload={flashMessagePayload}
                  onDismiss={dismissFlashMessage}
                  timeRemaining={FLASH_MESSAGE_TIMEOUT}
                />
              ) : undefined
            }
          >
            <P1>
              This organisation's parent and ultimate parent. If you change these, check for an existing parent, and only create a
              new one if necessary.
            </P1>
            <OrganizationGroupEditor
              value={{
                organizationGroupId: organization.organizationGroupId,
                parentOrganizationGroupId: organization.parentOrganizationGroupId,
                organizationGroup: organization.organizationGroup,
                parentOrganizationGroup: organization.parentOrganizationGroup,
              }}
              isUpdateLoading={isUpdateLoading}
              onUpdate={onUpdate}
            />
          </RepositCard>
        </Col>
      </Row>
    </Container>
  );
};

export default OrganizationGroup;
